var version = '1.1.1';
export default version;